<ng-content *ngIf="isActive"></ng-content>
